import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomMaterialModule } from './custom-material/custom-material.module';

import { AngularFireModule } from 'angularfire2';
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from 'angularfire2/database';

import { AngularDraggableModule } from 'angular2-draggable';

import { AppRoutingModule } from './/app-routing.module';

import { AppComponent } from './app.component';
import { TopComponent } from './top/top.component';
import { CompletedComponent } from './top/completed/completed.component';
import { PassPipe } from './pipe/pass.pipe';
import { EntryDatePipe } from './pipe/entry-date.pipe';
import { TodoListComponent } from './todo-list/todo-list.component';
import { DialogComponent } from './top/dialog/dialog.component';
import { DashboadComponent } from './dashboad/dashboad.component';
import { Dialog2Component } from './dashboad/dialog2/dialog2.component';
import { TotalkComponent } from './top/totalk/totalk.component';

@NgModule({
  declarations: [
    AppComponent,
    TopComponent,
    CompletedComponent,
    PassPipe,
    EntryDatePipe,
    TodoListComponent,
    DialogComponent,
    DashboadComponent,
    Dialog2Component,
    TotalkComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,ReactiveFormsModule,
    BrowserAnimationsModule,
    CustomMaterialModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularDraggableModule
  ],
  providers: [],
  entryComponents: [
    CompletedComponent,
    TotalkComponent,
    DialogComponent,
    Dialog2Component
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/app.module.ts